module.exports = __webpack_public_path__ + "lato-hairline-482fe0a9e92d9c5ff7fec117ca54c8ae.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-hairline/lato-hairline.woff
// module id = 1035
// module chunks = 0